import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {SelectFilterElement} from "../../../../../components/common/select-filter/select-filter.model";
import {LovValueSummary} from "../../../lov/lov-value/api/model/lovValueSummary.model";

@Component({
    selector: 'app-civility-select-filter',
    templateUrl: './civility-select-filter.component.html',
})
export class CivilitySelectFilterComponent implements AfterViewInit {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;

    @Output() singleSelectionChangedEvent: EventEmitter<string> = new EventEmitter();

    elements: BehaviorSubject<SelectFilterElement<string, string>[]> = new BehaviorSubject<SelectFilterElement<string, string>[]>([]);

    constructor() {

    }

    ngAfterViewInit(): void {
        this.elements.next([
            new SelectFilterElement('MR', 'MR', 'Monsieur'),
            new SelectFilterElement('MRS', 'MRS', 'Madame'),
            new SelectFilterElement('MISS', 'MISS', 'Mademoiselle'),
            new SelectFilterElement('UNKNOWN', 'UNKNOWN', 'Préfère ne pas répondre'),
        ]);
    }


    filter = (criteria: string, element: string) => {
        return element.toUpperCase().startsWith(criteria.toUpperCase());
    }

}
